/* eslint-disable eqeqeq */
import React, { useState, useLayoutEffect, useEffect } from "react";

/** Package */
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

/** Api */
import { getBanks, getCIMenu, getCI, getCustomers } from "./../../../services/api";
import { convertQueryStringToObject, updateNode } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Component */
import { Button, TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Dialog, Tooltip } from "@mui/material";
import InvoiceViewer from "../commons/InvoiceViewer.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import LoadingProgress from "../../commons/LoadingProgress.component";
import { FilterBy } from "../../commons/filter.component";
import { TreeMenu } from "../../commons/renderTreeMenu.component";
import { ticketStatusOptions } from "../../commons/SelectStatusButton";

/** Icon */
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

/** Package */
import moment from "moment";

/** Hook */
import { statusColor } from "../../config";
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

export default function CI() {
  const [t] = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const location = useLocation();
  const { id } = useParams();
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getCI);
  const filter = convertQueryStringToObject(location.search);

  const [input, setInput] = useState({
    customer: null,
    start_date: filter.start_date || null,
    end_date: filter.end_date || null,
    bank: null,
    status: "",
  });
  const [treeData, setTreeData] = useState();
  // state

  const handleRowClick = (e, id) => {
    history.push(`/ci/${id}${location.search}`);
  };
  const handleDeleteResponse = (res, deletedId) => {
    if (res.code === 200) {
      setData((prev) => updateNode(prev, (data) => data.map((item) => (item.id == deletedId ? { ...item, status: "DELETED" } : item))));
    }
  };
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, customer: undefined, customer_id: input.customer?.id, bank: null, bank_id: input.bank?.id }));
    getCIMenu().then((res) => {
      setTreeData(res.data);
    });
  };
  // effect
  useLayoutEffect(() => {
    fetchData(filter);
    getCIMenu().then((res) => {
      setTreeData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN HOÁ ĐƠN THƯƠNG MẠI"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button variant="outlined" onClick={() => history.push("/ci/create")}>
            <Tooltip title="Tạo mới">
              <AddIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* Fillter Bar */}
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.customer || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
            label={t("Khách hàng")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == filter.customer_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.customer_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getBanks({ status: 1 })}
            value={input.bank || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, bank: newValue }))}
            label={t("Ngân hàng")}
            getOptionLabel={(option) => option.vi_name}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, bank: option.find((item) => item.id == filter.bank_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.bank_id]}
          />
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Từ ngày")}
            value={input.start_date}
            onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
            sx={{ minWidth: "200px", margin: "5px" }}
          />
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Đến ngày")}
            value={input.end_date}
            onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
            sx={{ minWidth: "200px", margin: "5px" }}
          />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
            label={t("Trạng thái")}
            getOptionLabel={(option) => t(option) || ""}
            isOptionEqualToValue={(option, value) => option === value}
            getDataFunc={() => Promise.resolve({ data: ticketStatusOptions, code: 200 })}
            value={input?.status || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((item) => item == filter.status) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.status]}
          />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          <TreeMenu data={treeData} onClick={(query) => fetchData((prev) => ({ ...query, type: prev.type, per_page: prev.per_page }))} isExpand={!isSearchOpen} onExpand={() => setSearchOpen(false)} />
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "100%" }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      ID
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", minWidth: 200, backgroundColor: "#f0f3f5" }} align="center">
                      {t("Khách hàng")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Số chứng từ")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Ngày phát hành")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Từ ngày")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Đến ngày")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Ngày đến hạn")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      Đơn vị tính
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      Số lượng
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Tiền tệ")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Tổng tiền")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Người tạo")}
                    </TableCell>
                    <TableCell style={{ border: "1px solid gray", backgroundColor: "#f0f3f5" }} align="center">
                      {t("Trạng thái")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow hover style={{ cursor: "pointer", backgroundColor: id === item.id ? "lightgray" : "" }} key={index} onClick={(e) => handleRowClick(e, item.id)}>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="left">
                          {item.customer_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="left">
                          {item.code}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {moment(item.effective_time).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {moment(item.period_start_time).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {moment(item.period_end_time).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {moment(item.end_effective_time).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {item.unit}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="right">
                          {item.quantity?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center">
                          {item.currency}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="right">
                          {(+item.total)?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="left">
                          {item.staft}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} align="center" padding="checkbox">
                          <div className={`status ${item.status}`} style={{ color: statusColor[item.status], whiteSpace: "nowrap" }}>
                            {t(item.status)}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
        <Detail id={id} onClose={() => history.push(`/ci${location.search}`)} onDelete={handleDeleteResponse} />
      </div>
    </div>
  );
}

const Detail = ({ id, onClose, onDelete }) => {
  return (
    <Dialog open={Boolean(id)} onClose={onClose} fullWidth maxWidth={false}>
      <div style={{ padding: 10, height: "100vh" }}>
        <InvoiceViewer idParams={id} deleteResponse={onDelete} />
      </div>
    </Dialog>
  );
};
